import { Injectable } from '@angular/core';
import { ClaimsApiService } from '@ecosure-suite/shared/data-access';
import { LogService } from '@ecosure-suite/shared/util-logging';
import { NotificationsService } from '@ecosure-suite/shared/utils-notifications';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClaimDocumentType } from './+state/claim-document-types.reducer';

@Injectable({
  providedIn: 'root'
})
export class ClaimDocumentTypesService {
  constructor(
    private apiService: ClaimsApiService,
    private logService: LogService,
    private notificationsService: NotificationsService
  ) {}

  get(): Observable<ClaimDocumentType[]> {
    return this.apiService.get(`/documentTypes`).pipe(
      map(data => {
        if (data.statusCode !== '200') {
          this.notificationsService.showError(
            'Error',
            'Failed to load document types'
          );
          throw new Error(data.message);
        }
        return data.responseBody.map(
          type =>
            ({
              id: type.documentTypeId,
              typeId: type.documentTypeId,
              typeName: type.documentTypeName,
              description: type.description,
              ownerType: type.documentOwnerType,
              mandatory: type.mandatory,
              numberOfDocumentsAllowed: type.numberOfDocsAllowed,
              claimLineTypeId: type.claimLineTypeId
            } as ClaimDocumentType)
        );
      })
    );
  }
}
